export default __webpack_public_path__ + "static/media/62.b86b9612.svg";